import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useFetchPatientAndActiveTreatment } from "@/infra/apis/patients/useFetchPatientAndActiveTreatment";
import { trackAppClosed } from "@/infra/observability/analyticsService";
import { useTrackCareEventInfo } from "@akina/infra";
import { isApp } from "@akina/utils";
import { getCurrentWindow } from "@tauri-apps/api/window";

export const useTrackAppClosed = () => {
  const location = useLocation();
  const { patient, activeTreatment } = useFetchPatientAndActiveTreatment();
  const { data: careData, addPatientAndTreatmentData } = useTrackCareEventInfo({
    pageName: location.pathname,
  });

  const dataRef = useRef({ patient, activeTreatment, careData, addPatientAndTreatmentData });
  dataRef.current = { patient, activeTreatment, careData, addPatientAndTreatmentData };

  useEffect(() => {
    dataRef.current = { patient, activeTreatment, careData, addPatientAndTreatmentData };
  }, [patient, activeTreatment, careData, addPatientAndTreatmentData]);

  useEffect(() => {
    if (!isApp) return;
    if (isExternal(location.pathname)) return;
    const unlisten = getCurrentWindow().onCloseRequested(async event => {
      event.preventDefault();
      try {
        const { patient, activeTreatment, careData, addPatientAndTreatmentData } = dataRef.current;
        // fire and forget, do not await
        trackAppClosed({
          ...addPatientAndTreatmentData(patient, activeTreatment, careData),
        });
      } finally {
        getCurrentWindow().destroy();
      }
    });
    return () => {
      unlisten.then(unlisten => unlisten());
    };
  }, [location.pathname]);
};

function isExternal(pathname: string) {
  return pathname.includes("login");
}
